import styled from 'styled-components';

import {
  SearchBarList,
  SearchBarListItem,
} from '@components/ui/search/SearchResultListStyle';

export const AirportsContainer = styled.div`
  position: relative;
  display: flex;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    flex-direction: column;
  }
`;

export const AirportWrapper = styled.div`
  flex: 1;
  height: 100%;

  &.location-animation-error {
    border: 1px solid ${({ theme }) => theme.palette.coral};
    animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  }

  @keyframes shake {
    10%,
    90% {
      transform: translate3d(-1px, 0, 0);
    }

    20%,
    80% {
      transform: translate3d(2px, 0, 0);
    }

    30%,
    50%,
    70% {
      transform: translate3d(-4px, 0, 0);
    }

    40%,
    60% {
      transform: translate3d(4px, 0, 0);
    }
  }
`;

export const AirportCity = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.darkGray};
  opacity: 0.5;
  font-weight: bold;
`;

export const AirportList = styled(SearchBarList)``;

export const AirportListItem = styled(SearchBarListItem)``;

export const ArrivalAirportIconWrapper = styled.div`
  margin-left: 5px;
`;
